class modalTaxDiskCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest) {
        $scope.ukeyItem = items1.list
        const { orgList } = $scope.userInfo
        const orgListLen = orgList.length;
        // 状态文本转化
        (function () {
            for (const a in $scope.ukeyItem) {
                if ($scope.ukeyItem[a].status === 1) {
                    $scope.ukeyItem[a].statusText = '已启用'
                }
                if ($scope.ukeyItem[a].status === 0) {
                    $scope.ukeyItem[a].statusText = '未启用'
                }
                for (let i = 0; i < orgListLen; i++) {
                    if ($scope.ukeyItem[a].orgId === orgList[i].orgId) {
                        $scope.ukeyItem[a].orgName = orgList[i].orgName
                    }
                }
            }
        }())

        $scope.ukeyItemNum = items1.total
        // 分页参数
        $scope.pageOpt2 = {
            totalItems: items1.total, // 组件初始化设置总页数
            currentPage: ++items1.prePage, // 设置显示第一页
            maxSize: items1.pageSize, // 每一叶显示记录数
        }
        function queryUkeyList(v) {
            const req = {
                pageNum: $scope.pageOpt2.currentPage,
                pageSize: $scope.pageOpt2.maxSize,
                param: {
                    diskCodeName: '',
                    diskId: items1.param.diskId,
                    status: '', // 1只查询正在使用的ukey,按查询值则使用$scope.param1.param.status
                    ukeyCodeName: '',
                },
            }
            httpRequest.post_getSysUkeyList(req).then((res) => {
                $scope.ukeyItem = res.data.value.list;
                // 状态文本转化
                (function () {
                    for (const a in $scope.ukeyItem) {
                        if ($scope.ukeyItem[a].status === 1) {
                            $scope.ukeyItem[a].statusText = '已启用'
                        }
                        if ($scope.ukeyItem[a].status === 0) {
                            $scope.ukeyItem[a].statusText = '未启用'
                        }
                        for (let i = 0; i < orgListLen; i++) {
                            if ($scope.ukeyItem[a].orgId === orgList[i].orgId) {
                                $scope.ukeyItem[a].orgName = orgList[i].orgName
                            }
                        }
                    }
                }())
                $scope.pageOpt2.totalItems = res.data.value.total
                $scope.pageOpt2.currentPage = ++res.data.value.prePage
                $scope.pageOpt2.maxSize = res.data.value.pageSize
            })
        }

        $scope.pageChanged2 = function () {
            queryUkeyList(items1.param.diskId)
        }

        // 关闭
        $scope.ok = function () {
            $uibModalInstance.dismiss('cancel')
        }
    }
}
modalTaxDiskCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest']
export default modalTaxDiskCtrl



// WEBPACK FOOTER //
// ./src/app/system/basedata/ticketedPoint/modalTaxDiskCtrl.js